import { BaseOption } from 'ui/selectv2/types';
import { List } from '../../../types';

export const getListOptions = (lists: List[]): BaseOption<string>[] =>
  lists.map(({ id, name }) => ({
    label: name,
    value: id.toString(),
    Suffix: id.toString(),
  }));
